
function initDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open("wbuy_aiDatabase", 1);

        request.onupgradeneeded = function (event) {
            const db = event.target.result;

            // Status da conexão e registro de usuários
            if (!db.objectStoreNames.contains('mywbuy_ai')) {
                // Criando a object store
                const store = db.createObjectStore('mywbuy_ai', { keyPath: 'id' });
            }

            // Criação da tabela 'commands'
            if (!db.objectStoreNames.contains('commands')) {
                const usersStore = db.createObjectStore('commands', { keyPath: 'id' });
                usersStore.createIndex('by_timestamp', 'timestamp');
            }


        };

        request.onsuccess = function (event) {
            resolve(event.target.result);
        };

        request.onerror = function (event) {
            console.log(event.target.errorCode);
            reject('Database error: ' + event.target.errorCode);
        };
    });
}






// --------------------------------------------------------------------------------------------



function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


export {

    initDB,
    

};